<template>
  <div class="create-partner">
    <PartnerForm mode="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    PartnerForm: () => import(/* webpackChunkName: "PartnerForm" */ '@/views/Partner/PartnerForm')
  }
}
</script>
